/**
 * Reusable Schema.org JSON-LD builders.
 * All output is plain objects — pass to <SEO jsonLd={...} />.
 */

const SITE_URL = "https://visualizewithviz.com";
const ORG_NAME = "VIZ";
const ORG_LOGO = `${SITE_URL}/favicon.png`;

export const organizationLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: ORG_NAME,
  url: SITE_URL,
  logo: ORG_LOGO,
  sameAs: [],
});

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: ORG_NAME,
  url: SITE_URL,
});

export const breadcrumbLd = (items: Array<{ name: string; path: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const faqLd = (qa: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: qa.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});

export const articleLd = (post: {
  title: string;
  description: string;
  slug: string;
  date: string;
  modified?: string;
  author: { name: string; url?: string };
  image?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.title,
  description: post.description,
  image: post.image ?? `${SITE_URL}/og-image.jpg`,
  datePublished: post.date,
  dateModified: post.modified ?? post.date,
  author: {
    "@type": "Person",
    name: post.author.name,
    ...(post.author.url ? { url: post.author.url } : {}),
  },
  publisher: {
    "@type": "Organization",
    name: ORG_NAME,
    logo: { "@type": "ImageObject", url: ORG_LOGO },
  },
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": `${SITE_URL}/blog/${post.slug}`,
  },
});
